import { useMemo } from 'react'

export const useCopyRights = (onlyKwai = false) => {
  return useMemo(() => {
    const year = new Date().getFullYear()
    return `Copyright © 2016-${year} Kwai for Business. All Rights Reserved`
  }, [])
}
